var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "10 50 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer3",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,0.1,7,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,110C87.596,110 110,132.404 110,160C110,187.596 87.596,210 60,210C32.404,210 10,187.596 10,160C10,132.404 32.404,110 60,110ZM200,110C227.596,110 250,132.404 250,160C250,187.596 227.596,210 200,210C172.404,210 150,187.596 150,160C150,132.404 172.404,110 200,110Z",
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,0.1,7,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.169,85L111.606,85C108.565,85 105.603,85.552 102.844,86.587L97.208,73.908C94.801,68.491 89.429,65 83.501,65C77.662,65 70,65 70,65C67.24,65 65,67.24 65,70C65,72.76 67.24,75 70,75L83.501,75C85.477,75 87.268,76.164 88.07,77.969L94.293,91.969C92.588,93.602 91.104,95.49 89.9,97.597C83.167,109.38 71.958,128.996 64.208,142.558C61.555,147.2 61.574,152.904 64.258,157.529C66.942,162.154 71.885,165 77.232,165L125,165L125,190C125,192.76 127.24,195 130,195C132.76,195 135,192.76 135,190L135,161.385L170.09,102.902L195.404,161.97C196.22,163.873 198.077,165.01 200.026,165.001L200.27,164.994C200.84,164.963 201.414,164.834 201.97,164.596C204.508,163.508 205.684,160.569 204.596,158.03L176.436,92.325L185.201,77.717C187.981,73.083 188.054,67.312 185.391,62.609C182.728,57.907 177.742,55 172.338,55C165.823,55 160,55 160,55C157.24,55 155,57.24 155,60C155,62.76 157.24,65 160,65L172.338,65C174.139,65 175.802,65.969 176.689,67.536C177.577,69.104 177.552,71.028 176.626,72.572L169.169,85ZM98.821,102.157L98.583,102.558L72.891,147.519C72.006,149.067 72.013,150.968 72.907,152.51C73.802,154.051 75.449,155 77.232,155C77.232,155 122.306,155 122.306,155L98.821,102.157ZM163.169,95L111.606,95C109.989,95 108.409,95.26 106.918,95.753L130.662,149.178L163.169,95Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.9f8612237ed1fc65482b44ab524aa34b.svg";
export { ForwardRef as ReactComponent };